<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div
                :class="cardBorderClass"
                :style="{background: borderColor}"
            ></div>

            <div class="BaseStatCard__title-bar">
                <div class="BaseStatCard__title">
                    <slot name="title">
                        <slot name="titleIcon"></slot>
                        <span class="BaseStatCard__title-text">{{ title }}</span>
                    </slot>
                </div>
                <div class="BaseStatCard__action-container">
                    <slot name="action">
                        <a
                            v-if="!showCardLink"
                            class="BaseStatCard__card-link"
                            @click="$emit('nav', cardLink)"
                        >{{ cardLinkText }}</a>
                    </slot>
                </div>
            </div>

            <slot name="content"></slot>
        </template>
    </div>
</template>
<script>
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPBaseStatCard',
    props: {
        borderColor: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Default Title'
        },
        cardLink: {
            type: String,
            default: '',
        },
        cardLinkText: {
            type: String,
            default: 'Report',
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
        background: {
            type: String,
            default: 'white'
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder(
                'BaseStatCard',
                this.status,
                false,
                {
                    [this.background]: true,
                }
            );
        },
        cardBorderClass(){
            return statusBuilder(
                'BaseStatCard__top-border',
                this.status,
                false,
                {
                    custom: this.borderColor !== ''
                }
            );
        },
        showCardLink(){
            return this.cardLink === '';
        },
    }
};
</script>
<style lang="scss">
    .BaseStatCard {
        width: 100%;
        @include loading(9rem, 100%);
        @media(max-width: $max-md-width){
            &:not(:last-child){
                margin-bottom: 1rem;
            }
        }

        min-height: 10rem;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        display: flex;
        flex-direction: column;

        &--white {
            background: $white;
        }
        &--grey {
            background: $grey-50;
        }

        &__top-border {
            display: block;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            height: 0.25rem;
            width: 100%;
            @include loading(0.25rem, 100%);
            &--success { background-image: $gradient-positive; }
            &--warning { background-image: $gradient-yellow; }
            &--error { background-image: $gradient-negative; }
            &--custom { background-image: none; }
        }
        &__title-bar {
            display: flex;
            justify-content: space-between;
            padding: 1rem;
        }
        &__title {
            color: $text-dark;
            font-weight: 600;
            display: flex;
            align-items: center;
            flex-grow:1;
        }
        &__title-text:not(:first-child) {
            margin-left: 0.5rem;
        }
        &__card-link {
            cursor: pointer;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
</style>
